import { useEffect, useRef, useState } from "react";

const useMounted = (callback?: (any?: any) => void) => {
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) return;

    mounted.current = true;
    callback && callback();
  }, []);

  return mounted.current;
};

export default useMounted;
